/* eslint-disable */
import store from "../../store";
import Errors from "../../Errors";
import {API_BASE_ADMIN_URL, BASE_ADMIN_URL} from '../../config';
import CartHelpersMixin from "../../mixins/CartHelpersMixin";
import ProductHelpersMixin from "../../mixins/ProductHelpersMixin";

export default {
    mixins: [CartHelpersMixin, ProductHelpersMixin],

    props: [
        "customerEmail",
        "customerPhone",
        "gateways",
        "defaultAddress",
        "addresses",
        "countries",
        'sessionKey',
        'userId',
        'product',
        'termsAndConditions',
        'setup'
    ],

    data() {
        return {
            form: {
                customer_email: this.customerEmail,
                customer_phone: this.customerPhone,
                billing: {},
                shipping: {},
                billingAddressId: null,
                shippingAddressId: null,
                newBillingAddress: false,
                newShippingAddress: false,
                ship_to_a_different_address: false,
                flag_terms_and_condition: false,
                contract_id: null,
                agreement_id: null,
                order_id: null,
                project: {
                    name: '',
                    url: '',
                    clickup_url: '',
                    domain: '',
                    transfer_domain: '',
                    emails: '',
                    transfer_emails: '',
                    target_audience: '',
                    key_benefit: '',
                    target_goals: '',
                    call_to_action: '',
                    target_features: '',
                    business_description: '',
                    asset_inventory: '',
                    content: '',
                    text: '',
                    interactions: '',
                    links: '',
                    special_requests: ''
                },
                terms_ang_agree_checkbox: false,
                disable_button_terms_and_agree: false,
                tax: 0,
                setup_cost: 0,
            },
            states: {
                billing: {},
                shipping: {},
            },
            placingOrder: false,
            errors: new Errors(),
            stripe: null,
            stripeCardElement: null,
            stripeError: null,
            authorizeNetToken: null,
            term_id: null,
            images: {
                logo: null,
                menubar: null,
                color_pallet: null,
                corporate_identity: null,
                team_images: null,
                media: null
            },
        };
    },

    computed: {
        hasAddress() {
            return Object.keys(this.addresses).length !== 0;
        },

        firstCountry() {
            return Object.keys(this.countries)[0];
        },

        hasBillingStates() {
            return Object.keys(this.states.billing).length !== 0;
        },

        hasShippingStates() {
            return Object.keys(this.states.shipping).length !== 0;
        },

        hasNoPaymentMethod() {
            return Object.keys(this.gateways).length === 0;
        },

        firstPaymentMethod() {
            return Object.keys(this.gateways)[0];
        },

        shouldShowPaymentInstructions() {
            return ["bank_transfer", "check_payment"].includes(
                this.form.payment_method
            );
        },

        paymentInstructions() {
            if (this.shouldShowPaymentInstructions) {
                return this.gateways[this.form.payment_method].instructions;
            }
        },
    },

    watch: {
        "form.billingAddressId": function () {
            this.mergeSavedBillingAddress();
        },

        "form.shippingAddressId": function () {
            this.mergeSavedShippingAddress();
        },

        "form.billing.city": function (newCity) {
            if (newCity) {
                this.addTaxes();
            }
        },

        "form.shipping.city": function (newCity) {
            if (newCity) {
                this.addTaxes();
            }
        },

        "form.billing.zip": function (newZip) {
            if (newZip) {
                this.addTaxes();
            }
        },

        "form.shipping.zip": function (newZip) {
            if (newZip) {
                this.addTaxes();
            }
        },

        "form.billing.state": function (newState) {
            if (newState) {
                this.addTaxes();
            }
        },

        "form.shipping.state": function (newState) {
            if (newState) {
                this.addTaxes();
            }
        },

        "form.ship_to_a_different_address": function (newValue) {
            if (newValue && this.form.shippingAddressId) {
                this.form.shipping =
                    this.addresses[this.form.shippingAddressId];
            } else {
                this.form.shipping = {};
                this.resetAddressErrors("shipping");
            }

            this.addTaxes();
        },

        "form.terms_and_conditions": function () {
            this.errors.clear("terms_and_conditions");
        },

        "form.payment_method": function (newPaymentMethod) {
            if (newPaymentMethod === "paypal") {
                this.$nextTick(this.renderPayPalButton);
            }

            if (newPaymentMethod !== "stripe") {
                this.stripeError = "";
            }
        },

        "form.terms_ang_agree_checkbox": function(newValue) {
            if (!newValue) {
                this.form.flag_terms_and_condition = false;
                this.form.disable_button_terms_and_agree = false;
            }
        }
    },

    created() {
        console.log(process.env.VUE_APP_VAR1)

        if (this.defaultAddress.address_id) {
            this.form.billingAddressId = this.defaultAddress.address_id;
            this.form.shippingAddressId = this.defaultAddress.address_id;
        }

        if (!this.hasAddress) {
            this.form.newBillingAddress = true;
            this.form.newShippingAddress = true;
        }

        this.$nextTick(() => {
            this.changePaymentMethod(this.firstPaymentMethod);

            if (store.state.cart.shippingMethodName) {
                this.changeShippingMethod(store.state.cart.shippingMethodName);
            } else {
                this.updateShippingMethod(this.firstShippingMethod);
            }

            if (window.Stripe) {
                this.stripe = window.Stripe(FleetCart.stripePublishableKey);

                this.renderStripeElements();
            }
        });

        this.contract_id = store.state.cart.items[Object.keys(store.state.cart.items)[0]].product.contract_id,Object.keys(store.state.cart.items)[0];

        if (this.setup) {
            this.form.setup_cost = this.setup.cost;
        }
    },

    methods: {
        getCurrentPrice(cartItem) {
            if (cartItem.product.price_type === 'Price Unit') {
                if (cartItem.product.price_ranges.length !== 0) {
                    var priceRange = cartItem.product.price_ranges.filter((el) => {
                        return parseInt(cartItem.qty) >= el.min_quantity && parseInt(cartItem.qty) <= el.max_quantity
                    })
                    if (priceRange != null && priceRange[0]?.price) {
                        return 'CHF&nbsp;' + (parseInt(cartItem.qty) * priceRange[0].price);
                    } else {
                        return 'CHF&nbsp;' + (parseInt(cartItem.qty) * cartItem.product.price_ranges[cartItem.product.price_ranges.length - 1].price);
                    }
                }
                return cartItem.unitPrice.inCurrentCurrency.formatted
            } else {
                return cartItem.total.formatted;
            }
        },
        onFileChangeLogo(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;
            console.log(files[0]);
            this.images.logo = files[0]
        },
        onFileChangeMenubar(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;
            console.log(files[0]);
            this.images.menubar = files[0]
        },
        onFileChangeColorPallet(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;
            console.log(files[0]);
            this.images.color_pallet = files[0]
        },
        onFileChangeCorporateIdentity(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;
            console.log(files[0]);
            this.images.corporate_identity = files[0]
        },
        onFileChangeTeamImage(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;
            console.log(files[0]);
            this.images.team_images = files[0]
        },
        onFileChangeMedia(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;
            console.log(files[0]);
            this.images.media = files[0]
        },
        async terms_and_conditions() {
            if (this.form.terms_ang_agree_checkbox) {
                this.form.flag_terms_and_condition = true;
                this.form.disable_button_terms_and_agree = true;
                $('#exampleModal').modal('hide');

                await $.ajax({
                    method: "POST",
                    url: `${API_BASE_ADMIN_URL}terms`,
                    headers: {
                        "Content-Type": "application/json",
                    },
                    data: JSON.stringify({
                        customer_id: this.userId,
                        category_term_and_condition_id: this.termsAndConditions.id,
                        url: this.termsAndConditions.file,
                        type: 'T&C_Renatal_Orders'
                    }),
                }).then((response) => {
                    if (response.success) {
                        this.term_id = response.term.id;
                    }
                }).catch((xhr) => {
                    this.$notify(xhr.responseJSON.message);
                });

                await $.ajax({
                    method: "DELETE",
                    url: `${API_BASE_ADMIN_URL}terms/${this.term_id}`,
                    headers: {
                        "Content-Type": "application/json",
                    },
                }).catch((xhr) => {
                    this.$notify(xhr.responseJSON.message);
                });

            } else {
                this.$notify('You must accept the terms');
                throw new Error('You must accept the terms');
            }
        },
        async agreement() {
            try {
                if (!this.contract_id) {
                    this.$notify('No contract found');
                    throw new Error('No contract found');
                }

                try {
                    const response = await fetch(`${API_BASE_ADMIN_URL}${this.sessionKey}/${this.contract_id}/agreements_by_token_contract`);
                    const data = await response.json();
                    if (data.success) {
                        this.agreement_id = data.agreement.id;
                        this.order_id = data.order_id;
                    }
                } catch (error) {
                    this.$notify(error);
                }

                if (!this.agreement_id) {
                    try {
                        await $.ajax({
                            method: "POST",
                            url: route("checkout.create.order"),
                            data: {
                                ...this.form,
                            },
                        }).then((response) => {
                            this.order_id = response.id;
                        }).catch((xhr) => {
                            this.$notify(xhr.responseJSON.message);
                            throw new Error(xhr.responseJSON.message);
                        });
                    } catch (error) {
                        throw error;
                    }

                    try {
                        const response = await fetch(`${API_BASE_ADMIN_URL}${this.sessionKey}/${this.contract_id}/create_agreement`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                productId: this.product.id,
                                customerId: this.userId,
                                orderId: this.order_id,
                            })
                        });
                        const data = await response.json();
                        console.log(data);
                        if (data.success) {
                            this.agreement_id = data.agreement.id;
                        }
                    } catch (error) {
                        this.$notify(error);
                    }
                }

                if (this.agreement_id) {
                    window.open(`${BASE_ADMIN_URL}/agreement/customer/preview/${this.agreement_id}/${this.userId}`, '_blank');
                }
            } catch (error) {
                this.$notify(error);
            }
        },
        addNewBillingAddress() {
            this.resetAddressErrors("billing");

            this.form.billing = {};
            this.form.newBillingAddress = !this.form.newBillingAddress;

            if (!this.form.newBillingAddress) {
                this.mergeSavedBillingAddress();
            }
        },

        addNewShippingAddress() {
            this.resetAddressErrors("shipping");

            this.form.shipping = {};
            this.form.newShippingAddress = !this.form.newShippingAddress;

            if (!this.form.newShippingAddress) {
                this.mergeSavedShippingAddress();
            }
        },

        // reset address errors based on address type
        resetAddressErrors(addressType) {
            Object.keys(this.errors.errors).map((key) => {
                key.indexOf(addressType) !== -1 && this.errors.clear(key);
            });
        },

        mergeSavedBillingAddress() {
            this.resetAddressErrors("billing");

            if (!this.form.newBillingAddress && this.form.billingAddressId) {
                this.form.billing = this.addresses[this.form.billingAddressId];
            }
        },

        mergeSavedShippingAddress() {
            this.resetAddressErrors("shipping");

            if (
                this.form.ship_to_a_different_address &&
                !this.form.newShippingAddress &&
                this.form.shippingAddressId
            ) {
                this.form.shipping =
                    this.addresses[this.form.shippingAddressId];
            }
        },

        changeBillingCity(city) {
            this.$set(this.form.billing, "city", city);
        },

        changeShippingCity(city) {
            this.$set(this.form.shipping, "city", city);
        },

        changeBillingZip(zip) {
            this.$set(this.form.billing, "zip", zip);
        },

        changeShippingZip(zip) {
            this.$set(this.form.shipping, "zip", zip);
        },

        changeBillingCountry(country) {
            this.$set(this.form.billing, "country", country);

            if (country === "") {
                this.form.billing.state = "";
                this.states.billing = {};

                return;
            }

            this.fetchStates(country, (states) => {
                this.$set(this.states, "billing", states);
                this.$set(this.form.billing, "state", "");
            });
        },

        changeShippingCountry(country) {
            this.$set(this.form.shipping, "country", country);

            if (country === "") {
                this.form.shipping.state = "";
                this.states.shipping = {};

                return;
            }

            this.fetchStates(country, (states) => {
                this.$set(this.states, "shipping", states);
                this.$set(this.form.shipping, "state", "");
            });
        },

        fetchStates(country, callback) {
            $.ajax({
                method: "GET",
                url: route("countries.states.index", { code: country }),
            }).then(callback);
        },

        changeBillingState(state) {
            this.$set(this.form.billing, "state", state);
        },

        changeShippingState(state) {
            this.$set(this.form.shipping, "state", state);
        },

        changePaymentMethod(paymentMethod) {
            this.$set(this.form, "payment_method", paymentMethod);
        },

        changeShippingMethod(shippingMethodName) {
            this.$set(this.form, "shipping_method", shippingMethodName);
        },

        addTaxes() {
            this.loadingOrderSummary = true;

            $.ajax({
                method: "POST",
                url: route("cart.taxes.store"),
                data: this.form,
            })
                .then((cart) => {
                    store.updateCart(cart);
                    if (cart.taxes[Object.keys(cart.taxes)[0]]) {
                        this.form.tax = cart.taxes[Object.keys(cart.taxes)[0]].amount.amount
                    }
                })
                .catch((xhr) => {
                    this.$notify(xhr.responseJSON.message);
                })
                .always(() => {
                    this.loadingOrderSummary = false;
                });
        },

        async placeOrder() {
            if (this.placingOrder) {
                return;
            }

            this.placingOrder = true;

            if (!this.contract_id) {
                this.$notify('No contract found');
                throw new Error('No contract found');
            }

            if (!this.form.flag_terms_and_condition) {
                this.$notify('Don\'t confirmed terms and conditions');
                this.placingOrder = false;
                throw new Error('Don\'t confirmed terms and conditions');
            }

            await $.ajax({
                method: "GET",
                url: `${API_BASE_ADMIN_URL}${this.sessionKey}/${this.contract_id}/check_sign_agreement_by_customer`,
                headers: {
                    "Content-Type": "application/json",
                },
            })
                .then((response) => {
                    if (response.success && response.signed) {
                        this.agreement_id = response.agreement.id;
                        this.form.terms_and_conditions = true;
                    }
                    if (!response.success || !response.signed) {
                        this.$notify('You must sign the terms and conditions and the contract');
                        throw new Error('You must sign the terms and conditions and the contract');
                    }
                })
                .catch((xhr) => {
                    this.$notify(xhr.responseJSON.message);
                    this.placingOrder = false;
                    throw new Error(xhr.responseJSON.message);
                });

            try {
                /*
                let data = new FormData();
                data.append('project[logo]', this.form.project.logo);
                data.append('project[menubar]', this.form.project.menubar);
                data.append('project[color_pallet]', this.form.project.color_pallet);
                data.append('project[corporate_identity]', this.form.project.corporate_identity);
                data.append('project[team_images]', this.form.project.team_images);
                data.append('project[media]', this.form.project.media);

                headers: {
                        "Content-Type": "multipart/form-data",
                    },
                 */

                console.log(this.form.billing);
                console.log(this.form.shipping);
                let data = new FormData();
                data.append('customer_email', this.form.customer_email);
                data.append('customer_phone', this.form.customer_phone);
                //data.append('billing', this.form.billing);
                for (let key in this.form.billing) {
                    data.append('billing[' + key +  ']', this.form.billing[key]);
                }
                //data.append('shipping', this.form.shipping);
                for (let key in this.form.shipping) {
                    data.append('shipping[' + key +  ']', this.form.shipping[key]);
                }
                data.append('billingAddressId', this.form.billingAddressId);
                data.append('shippingAddressId', this.form.shippingAddressId);
                data.append('newBillingAddress', this.form.newBillingAddress);
                data.append('newShippingAddress', this.form.newShippingAddress);
                data.append('flag_terms_and_condition', this.form.flag_terms_and_condition);
                data.append('ship_to_a_different_address', this.form.ship_to_a_different_address);
                data.append('payment_method', this.form.payment_method);
                data.append('terms_and_conditions', this.form.terms_and_conditions);

                if (this.setup) {
                    data.append('setup_cost', this.setup.cost)
                }

                for (let key in this.form.project) {
                    data.append('project[' + key +  ']', this.form.project[key]);
                }

                for (let key in this.images) {
                    data.append('project[' + key +  ']', this.images[key]);
                }
                /*
                data.append('project[name]', this.form.project.name);
                data.append('project[url]', this.form.project.url);
                data.append('project[clickup_url]', this.form.project.clickup_url);
                 */

                data.append('contract_id', this.contract_id);
                data.append('agreement_id', this.agreement_id);
                data.append('term_id', this.term_id);

                const response = await $.ajax({
                    method: "POST",
                    url: route("checkout.create"),
                    contentType: false,
                    processData: false,
                    //enctype: 'multipart/form-data',
                    data: data,
                    /*
                    data: {
                        ...this.form,
                        ship_to_a_different_address: +this.form.ship_to_a_different_address,
                        contract_id: this.contract_id,
                        agreement_id: this.agreement_id,
                        images: this.images,
                        data
                    },
                     */
                });
                /*
                const response = await $.ajax({
                    method: "POST",
                    url: route("checkout.create"),
                    //contentType: false,
                    //processData: false,
                    enctype: 'multipart/form-data',
                    data: {
                        ...this.form,
                        ship_to_a_different_address: +this.form.ship_to_a_different_address,
                        contract_id: this.contract_id,
                        agreement_id: this.agreement_id,
                        images: this.images
                    },
                });
                 */

                await this.connectToAgreement(response.orderId);

                if (response.redirectUrl) {
                    window.location.href = response.redirectUrl;
                } else if (this.form.payment_method === "stripe") {
                    this.confirmStripePayment(response);
                } else if (this.form.payment_method === "paytm") {
                    this.confirmPaytmPayment(response);
                } else if (this.form.payment_method === "razorpay") {
                    this.confirmRazorpayPayment(response);
                } else if (this.form.payment_method === "paystack") {
                    this.confirmPaystackPayment(response);
                } else if (this.form.payment_method === "authorizenet") {
                    this.confirmAuthorizeNetPayment(response);
                } else if (this.form.payment_method === "flutterwave") {
                    this.confirmFlutterWavePayment(response);
                } else if (this.form.payment_method === "mercadopago") {
                    this.confirmMercadoPagoPayment(response);
                } else {
                    this.confirmOrder(response.orderId, this.form.payment_method, {project: this.form.project});
                }

            } catch (xhr) {
                console.log(xhr);
                if (xhr.status === 422) {
                    this.errors.record(xhr.responseJSON.errors);
                }
                this.$notify(xhr.responseJSON.message);
                this.placingOrder = false;
                throw new Error(xhr.responseJSON.message);
            }
        },
        async connectToAgreement(orderId) {
            $.ajax({
                method: "POST",
                url: `${API_BASE_ADMIN_URL}${this.sessionKey}/${this.contract_id}/${orderId}/connect_to_agreement`,
                headers: {
                    "Content-Type": "application/json",
                },
            })
                .then((response) => {
                    if (!response.success) {
                        this.$notify(response.message);
                    }
                })
                .catch((xhr) => {
                    this.$notify(xhr.responseJSON.message);
                });
        },
        confirmOrder(orderId, paymentMethod, params = {}) {
            $.ajax({
                method: "GET",
                url: route("checkout.complete.store", {
                    orderId,
                    paymentMethod,
                    ...params,
                })
            })
                .then(() => {
                    window.location.href = route("checkout.complete.show");
                })
                .catch((xhr) => {
                    this.placingOrder = false;
                    this.loadingOrderSummary = false;

                    this.deleteOrder(orderId);
                    this.$notify(xhr.responseJSON.message);
                });
        },

        deleteOrder(orderId) {
            if (!orderId) {
                return;
            }

            $.ajax({
                method: "GET",
                url: route("checkout.payment_canceled.store", { orderId }),
            }).then((xhr) => {
                this.$notify(xhr.message);
            });
        },

        renderPayPalButton() {
            let vm = this;
            let response;

            window.paypal
                .Buttons({
                    async createOrder() {
                        try {
                            response = await $.ajax({
                                method: "POST",
                                url: route("checkout.create"),
                                data: vm.form,
                            });

                            return response.resourceId;
                        } catch (xhr) {
                            if (xhr.status === 422) {
                                vm.errors.record(xhr.responseJSON.errors);
                            } else {
                                vm.$notify(xhr.responseJSON.message);
                            }
                        }
                    },
                    onApprove() {
                        vm.loadingOrderSummary = true;

                        vm.confirmOrder(response.orderId, "paypal", response);
                    },
                    onError() {
                        vm.deleteOrder(response.orderId);
                    },
                    onCancel() {
                        vm.deleteOrder(response.orderId);
                    },
                })
                .render("#paypal-button-container");
        },

        renderStripeElements() {
            this.stripeCardElement = this.stripe.elements().create("card", {
                hidePostalCode: true,
            });

            this.stripeCardElement.mount("#stripe-card-element");
        },

        async confirmStripePayment({ orderId, clientSecret }) {
            let result = await this.stripe.confirmCardPayment(clientSecret, {
                payment_method: {
                    card: this.stripeCardElement,
                    billing_details: {
                        email: this.form.customer_email,
                        name: `${this.form.billing.first_name} ${this.form.billing.last_name}`,
                        address: {
                            city: this.form.billing.city,
                            country: this.form.billing.country,
                            line1: this.form.billing.address_1,
                            line2: this.form.billing.address_2,
                            postal_code: this.form.billing.zip,
                            state: this.form.billing.state,
                        },
                    },
                },
            });

            if (result.error) {
                this.placingOrder = false;
                this.stripeError = result.error.message;

                this.deleteOrder(orderId);
            } else {
                this.confirmOrder(orderId, "stripe", result);
            }
        },

        confirmPaytmPayment({ orderId, amount, txnToken }) {
            let config = {
                root: "",
                flow: "DEFAULT",
                data: {
                    orderId: orderId,
                    token: txnToken,
                    tokenType: "TXN_TOKEN",
                    amount: amount,
                },
                merchant: {
                    name: FleetCart.storeName,
                    redirect: false,
                },
                handler: {
                    transactionStatus: (response) => {
                        if (response.STATUS === "TXN_SUCCESS") {
                            this.confirmOrder(orderId, "paytm", response);
                        } else if (response.STATUS === "TXN_FAILURE") {
                            this.placingOrder = false;

                            this.deleteOrder(orderId);
                        }

                        window.Paytm.CheckoutJS.close();
                    },
                    notifyMerchant: (eventName) => {
                        if (eventName === "APP_CLOSED") {
                            this.placingOrder = false;

                            this.deleteOrder(orderId);
                        }
                    },
                },
            };

            window.Paytm.CheckoutJS.init(config)
                .then(() => {
                    window.Paytm.CheckoutJS.invoke();
                })
                .catch(() => {
                    this.deleteOrder(orderId);
                });
        },

        confirmRazorpayPayment(razorpayOrder) {
            this.placingOrder = false;

            let vm = this;

            new window.Razorpay({
                key: FleetCart.razorpayKeyId,
                name: FleetCart.storeName,
                description: `Payment for order #${razorpayOrder.receipt}`,
                image: FleetCart.storeLogo,
                order_id: razorpayOrder.id,
                handler(response) {
                    vm.placingOrder = true;

                    vm.confirmOrder(
                        razorpayOrder.receipt,
                        "razorpay",
                        response
                    );
                },
                modal: {
                    ondismiss() {
                        vm.deleteOrder(razorpayOrder.receipt);
                    },
                },
                prefill: {
                    name: `${vm.form.billing.first_name} ${vm.form.billing.last_name}`,
                    email: vm.form.customer_email,
                    contact: vm.form.customer_phone,
                },
            }).open();
        },

        confirmPaystackPayment({
            key,
            email,
            amount,
            ref,
            currency,
            order_id,
        }) {
            let vm = this;

            PaystackPop.setup({
                key,
                email,
                amount,
                ref,
                currency,
                onClose() {
                    vm.placingOrder = false;

                    vm.deleteOrder(order_id);
                },
                callback(response) {
                    vm.placingOrder = false;

                    vm.confirmOrder(order_id, "paystack", response);
                },
                onBankTransferConfirmationPending(response) {
                    vm.placingOrder = false;

                    vm.confirmOrder(order_id, "paystack", response);
                },
            }).openIframe();
        },

        confirmAuthorizeNetPayment(authorizeNetOrder) {
            this.authorizeNetToken = authorizeNetOrder.token;

            this.$nextTick(() => {
                this.$refs.authorizeNetForm.submit();

                this.authorizeNetToken = null;
            });
        },

        confirmFlutterWavePayment({
            public_key,
            tx_ref,
            order_id,
            amount,
            currency,
            payment_options,
            redirect_url,
        }) {
            let vm = this;

            FlutterwaveCheckout({
                public_key,
                tx_ref,
                amount,
                currency,
                payment_options: payment_options.join(", "),
                redirect_url,
                customer: {
                    email: this.form.customer_email,
                    phone_number: this.form.customer_phone,
                    name: this.form.billing.full_name,
                },
                customizations: {
                    title: FleetCart.storeName,
                    logo: FleetCart.storeLogo,
                },
                onclose(incomplete) {
                    vm.placingOrder = false;

                    if (incomplete) {
                        vm.deleteOrder(order_id);
                    }
                },
            });
        },

        confirmMercadoPagoPayment(mercadoPagoOrder) {
            this.placingOrder = false;

            const supportedLocales = {
                en_US: "en-US",
                es_AR: "es-AR",
                es_CL: "es-CL",
                es_CO: "es-CO",
                es_MX: "es-MX",
                es_VE: "es-VE",
                es_UY: "es-UY",
                es_PE: "es-PE",
                pt_BR: "pt-BR",
            };

            const mercadoPago = new MercadoPago(mercadoPagoOrder.publicKey, {
                locale:
                    supportedLocales[mercadoPagoOrder.currentLocale] || "en-US",
            });

            mercadoPago.checkout({
                preference: {
                    id: mercadoPagoOrder.preferenceId,
                },
                autoOpen: true,
            });
        },
    },
};
